import React from 'react';
import { Formik } from 'formik';
import Yup from 'yup';

import styles from '../onboardingFormStyles.scss';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import OnboardingCommunitySuggestionsContainer from 'buyside/components/container/Onboarding/OnboardingCommunitySuggestionsContainer';
import OnboardingFundSuggestions from 'buyside/components/presentation/Onboarding/OnboardingForm/OnboardingCommunitySuggestions/onboardingFundSuggestions';

const onboardingCommunityForm = ({ handleSubmit, isAllocator, watchlist }) => {
  return (
    <div className={styles.onboardingMainArea}>
      <h2 className={styles.onboardingFormHeader}>Build Your Community</h2>
      <div className={styles.onboardingFormInfo}>
        We recommend following at least 3 of the following{' '}
        <strong>Top Ranked Analysts{isAllocator ? '/Funds' : ''}</strong> by clicking "Follow" above
        their names. Following will ensure that you are alerted when they post new research.
      </div>
      <OnboardingCommunitySuggestionsContainer isAllocator={isAllocator} />
      <ErrorBoundary pageName="fund suggestions">
        {isAllocator && <OnboardingFundSuggestions />}
      </ErrorBoundary>
      <Formik onSubmit={handleSubmit} validationSchema={Yup.object()}>
        {props => <_onboardingCommunityFormikForm {...props} watchlist={watchlist} />}
      </Formik>
    </div>
  );
};

const _onboardingCommunityFormikForm = props => {
  const { handleSubmit, isSubmitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.nextSectionNav}>
        <Button
          text="Finish and Get Started"
          type={BUTTON_TYPES.PRIMARY}
          isLoading={isSubmitting}
          id="NextButton"
        />
      </div>
    </form>
  );
};

export default onboardingCommunityForm;
